import { Button, Modal } from "antd";
import React from "react";
import CustomTable from "../../../../../components/common/Table/CustomTable";
import UploadFile from "../../../../../components/common/UploadFile/UploadFile";
import SwalToast from "../../../../../components/helpers/SwalToast";
import { renderDetailCommissionColumn } from "../constants";

export default function ModalDetailCommission({
  visible,
  data,
  loading,
  handleTableChange,
  tablePagination,
  onClose,
  dataForModalDisburse,
  handleImageChange,
  handleUploadImage,
  transferProofImg,
  errors,
  uploadData,
  submitting,
  openConfirmDialog,
  handleReject,
}) {
  const onSubmit = () => {
    if (!uploadData) {
      SwalToast.fire({
        icon: "error",
        title: "Bukti transfer harus di upload",
      });
    } else {
      openConfirmDialog();
    }
  };
  return (
    <Modal
      title={"Detail Transaksi Pencairan Komisi"}
      visible={visible}
      onCancel={onClose}
      width={"60%"}
      centered
      footer={
        dataForModalDisburse
          ? [
              <Button
                disabled={submitting}
                key="back"
                onClick={onClose}
                className="btn-modal btn-default"
                style={{ width: "15%" }}
              >
                Kembali
              </Button>,
              // <Button
              //   disabled={submitting}
              //   key="back"
              //   onClick={handleReject}
              //   className="btn-modal btn-default"
              //   style={{ width: "15%", color: "#F23434" }}
              // >
              //   Batalkan
              // </Button>,
              <Button
                disabled={submitting}
                key="submit"
                type="primary"
                onClick={onSubmit}
                className="btn-modal"
                style={{ width: "15%" }}
              >
                Cairkan
              </Button>,
            ]
          : []
      }
    >
      <div className="py-2">
        <CustomTable
          columns={renderDetailCommissionColumn()}
          data={data}
          loading={loading}
          handleTableChange={handleTableChange}
          pagination={tablePagination}
          scrollX={800}
        />
      </div>
      {dataForModalDisburse && (
        <div>
          <div className="d-flex justify-content-end mt-1">
            <div className="col-2">Pajak :</div>
            <div className="col-2 d-flex justify-content-end">
              {dataForModalDisburse.taxAmount}
            </div>
          </div>
          <div className="d-flex justify-content-end mt-1">
            <div className="col-2">Biaya Admin :</div>
            <div className="col-2 d-flex justify-content-end">
              {dataForModalDisburse.feeAdmin}
            </div>
          </div>
          <div className="d-flex justify-content-end align-items-center">
            <div className="col-2">Bukti Transfer:</div>
            <div className="col-2 d-flex justify-content-end">
              <UploadFile
                id={"transferProof"}
                buttonText={!uploadData ? "Tambah File" : "Upload Ulang"}
                isForm={true}
                width="100%"
                handleImageChange={handleImageChange("transferProof")}
                customRequest={handleUploadImage("transferProof")}
                fileList={transferProofImg}
                errorText={errors.transferProof}
                style={{
                  marginTop: 15,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                showUploadList={false}
              />
            </div>
          </div>
          <div
            className="d-flex"
            style={{
              backgroundColor: "rgba(44, 70, 92, 0.14)",
              padding: 8,
              marginTop: 18,
              borderRadius: 10,
              justifyContent: "flex-end",
            }}
          >
            <div style={{ fontWeight: "500" }}>
              Total Komisi yang Harus Dicairkan :
            </div>
            <div style={{ fontWeight: "700", marginLeft: 3 }}>
              {dataForModalDisburse.commissionDisbursed}
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
}
